module.exports = __webpack_public_path__ + "static/CardOfDarkness5-e99e3c7da9504bc39c78637c3f8f2323.png";